__turbopack_context__.v({
  "logo": "footerLogo-module-scss-module__1PeYba__logo",
});
